module.exports = __webpack_public_path__ + "static/media/secureauth.ef8d6f3e.png";